import { defineModule } from "direct-vuex";
import { moduleActionContext } from "@/store";
import CriterionItemRequest from "@/models/api/filters/criterions/CriterionItemRequest";
import { ReportModel } from "@/models/api/report/Report";
import { showReports, generateReport, deleteReport } from "@/requests/report/report";
import { DataOptions } from "vuetify";
import { DefaultDataOptions } from "@/models/components/dataTables/DataTableOptions";

export interface ReportsGeneratorStateInterface {
  reportFilters: Array<CriterionItemRequest> | null;
  dataTableOptions: DataOptions;
  isLoading: boolean;
  reports: Array<ReportModel>;
  reportsCount: number | null;
  description: string;
  password: string;
}

export const ReportsGeneratorState: ReportsGeneratorStateInterface = {
  reportFilters: null,
  dataTableOptions: new DefaultDataOptions(),
  isLoading: true,
  reports: [],
  reportsCount: null,
  description: "",
  password: "",
};

const ReportsGeneratorModule = defineModule({
  state: ReportsGeneratorState as ReportsGeneratorStateInterface,
  namespaced: true as const,
  modules: {},
  getters: {},
  mutations: {
    setReportFilters(state, param: Array<CriterionItemRequest> | null) {
      state.reportFilters = param;
    },
    setIsLoading(state, param: boolean) {
      state.isLoading = param;
    },
    setReports(state, param: Array<ReportModel>) {
      state.reports = param;
    },
    setReportsCount(state, param: number | null) {
      state.reportsCount = param;
    },
    setDataTableOptions(state, param: DataOptions) {
      state.dataTableOptions = param;
    },
    setDescription(state, param: string) {
      state.description = param;
    },
  },
  actions: {
    async downloadReports(context) {
      const { commit, state, rootState } = _moduleActionContext(context);
      commit.setIsLoading(true);
      const reports = await showReports(
        rootState.reports.activeReportType[0],
        state.dataTableOptions.page - 1,
        state.dataTableOptions.itemsPerPage
      );
      commit.setReports(reports.items);
      commit.setReportsCount(reports.totalCount);
      commit.setIsLoading(false);
    },

    async deleteReport(context, reportId: string) {
      const { rootDispatch, dispatch } = _moduleActionContext(context);
      await rootDispatch.failIfRequestsInProgress();
      await deleteReport(reportId);
      await dispatch.downloadReports();
    },

    async generate(context) {
      const { commit, state, rootState, rootDispatch, dispatch } = _moduleActionContext(context);
      await rootDispatch.failIfRequestsInProgress();
      commit.setIsLoading(true);
      if (rootState.reports.activeReportFilterName && rootState.reports.activeReportGeneratorType) {
        await generateReport(
          state.reportFilters,
          rootState.reports.activeReportFilterName,
          rootState.reports.activeReportType[0],
          rootState.reports.activeReportGeneratorType,
          state.description,
          rootState.reports.culture,
          state.password
        ).finally(() => {
          commit.setIsLoading(false);
        });
      }
      commit.setIsLoading(false);
      await dispatch.downloadReports();
    },
  },
});
export default ReportsGeneratorModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, ReportsGeneratorModule);
